'use client'

import { Menu, Button } from '@mantine/core'
import { RiArrowUpDownFill } from '@remixicon/react'

export type SortOption =
  | 'reviews_high_to_low'
  | 'price_low_to_high'
  | 'price_high_to_low'

interface SortDropdownProps {
  onSortChange?: (value: SortOption) => void
  currentSort?: SortOption | string
  isMobileVisible?: boolean
}

const SORT_OPTIONS: Array<{ value: SortOption; label: string }> = [
  { value: 'reviews_high_to_low', label: 'Most Reviewed' },
  { value: 'price_low_to_high', label: 'Price: Low to High' },
  { value: 'price_high_to_low', label: 'Price: High to Low' },
]

export default function SortDropdown({
  onSortChange,
  currentSort = 'reviews_high_to_low',
  isMobileVisible = false,
}: SortDropdownProps) {

  const handleSort = (option: SortOption) => {
    if (onSortChange) {
      onSortChange(option)
    }
  }

  return (
    <Menu>
      <Menu.Target>
        <Button
          radius='xl'
          size='xs'
          variant='subtle'
          className={`${isMobileVisible ? 'flex' : 'hidden md:flex'} !bg-[#F5F5F5] text-[#06070A] px-3 !h-[40px] md:!h-[37px] w-auto min-w-[104px] !border !border-[#E0E0E0] md:!border-0 shadow-none`}
        >
          <div className='flex items-center gap-2'>
            <RiArrowUpDownFill size={16} />
            <span className='text-[#06070A] text-[13px] font-medium'>
              Sort by
            </span>
          </div>
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {SORT_OPTIONS.map((option) => {
          const isSelected = currentSort === option.value

          return (
            <Menu.Item
              key={option.value}
              onClick={() => handleSort(option.value)}
              aria-current={isSelected ? 'true' : undefined}
              rightSection={
                isSelected ? (
                  <span className='h-2 w-2 rounded-full bg-[#80c7e2]' />
                ) : null
              }
              className={
                isSelected
                  ? '!bg-[#EAF7FB] !text-[#06070A] border-l-2 border-[#80c7e2] font-semibold'
                  : 'font-medium text-[#06070A]'
              }
            >
              {option.label}
            </Menu.Item>
          )
        })}
      </Menu.Dropdown>
    </Menu>
  )
}
